import { render, staticRenderFns } from "./dialog-confirmdelete.vue?vue&type=template&id=3fcfd6ce&"
import script from "./dialog-confirmdelete.vue?vue&type=script&lang=js&"
export * from "./dialog-confirmdelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports